import { useQueryClient } from '@tanstack/react-query';
import { Modal, Typography, message } from 'antd';

import { useCancelOrderProdct } from '@/hooks/mutations/partner';
import { getQueryKey } from '@/utils/queryKeys';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
}

const CancelOrderModal = ({ onClose, isOpen, orderId }: Props) => {
  const queryClient = useQueryClient();

  const cancelOrderProduct = useCancelOrderProdct({
    onSuccess: () => {
      message.success('정상적으로 취소되었어요');
      queryClient.invalidateQueries({
        queryKey: getQueryKey('getProductOrder', {
          id: Number(orderId),
        }),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKey('getProductOrders'),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKey('admin:getProductOrder', {
          id: Number(orderId),
        }),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKey('admin:getProductOrders'),
      });
      onClose();
    },
  });

  return (
    <Modal
      centered
      width={320}
      open={isOpen}
      onClose={onClose}
      onCancel={onClose}
      okButtonProps={{
        loading: cancelOrderProduct.isPending,
      }}
      onOk={() => {
        cancelOrderProduct.mutate({
          id: orderId,
        });
      }}
      okText="네 취소할게요"
      title="신청 취소"
    >
      <Typography.Text type="secondary">
        상품 신청 내역을 취소하시겠어요?
      </Typography.Text>
    </Modal>
  );
};

export default CancelOrderModal;
